<template>
    <!--/* POPIN étapes de déménagement */-->
    <ob1-popin-modal2
        :id="popinModal.id"
        :aria-labelledby="popinModal.label"
        :show-close-button="popinModal.showCloseButton"
        @ob1-popin-modal-click="closePopin"
    >
        <h4 id="modalTitle">
            {{ title }}
        </h4>
        <div class="row pt-2">
            <div class="col-12">
                <div class="accordion">
                    <div v-for="(step, index) in steps" :key="'step-' + index">
                        <div class="card multi">
                            <div :id="'heading-step-' + index" class="card-header">
                                <button
                                    class="collapsed"
                                    data-bs-toggle="collapse"
                                    :data-bs-target="'#step-collapse-'+ index"
                                    :aria-controls="'#' + 'step-collapse-'+ index"
                                    :aria-expanded="expandedStepIndex === index ? 'true' : 'false'"
                                >
                                    <span class="accordion-card-title">
                                        <span class="step-bubble-popin me-1" aria-hidden="true" v-html="step.number" />
                                        <span class="accordion-title" itemprop="name" v-html="step.title" />
                                        <span class="accordion-icon" aria-hidden="true" />
                                    </span>
                                </button>
                            </div>
                            <div
                                :id="'step-collapse-'+ index"
                                class="collapse"
                                :class="{'show': expandedStepIndex === index}"
                                :aria-labelledby="'step-attributes-'+ index"
                            >
                                <div class="accordion-card-body standard">
                                    <ul class="list ob1-list-tick">
                                        <li
                                            v-for="(attribute, pointer) in step.attributes"
                                            :key="'step-attribute-' + pointer"
                                        >
                                            <span v-html="attribute.text" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "DemenagementStepsPopin",
    props: {
        dto: {
            type: Object,
            required: true
        },
        expandedStepIndex: {
            type: Number,
            required: true
        }
    },
    computed: {
        popinModal() {
            return this.dto.popinModal;
        },
        title() {
            return this.dto.title;
        },
        steps() {
            return this.dto.steps;
        }
    },
    methods: {
        closePopin() {
            this.$nextTick(() => {
                const rootEl = this.$el;
                const openCollapses = rootEl.querySelectorAll('.collapse.show');

                openCollapses.forEach((el) => {
                    el.classList.remove('show');
                    const btn = rootEl.querySelector(`[data-bs-target="#${el.id}"]`);
                    if (btn) {
                        btn.setAttribute('aria-expanded', 'false');
                        const card = btn.closest('.card');
                        if (card) {
                            card.classList.remove('card-expanded');
                        }
                    }
                });
            });
        }
    }
}
</script>
